export default __webpack_public_path__ + "static/media/marker19.624a54ac.svg";